import ChartPie from '@/components/charts/pie/index.vue';
import DialogEvent from '@/components/dialog-event/index.vue';

export const CommonComponents = {
  'mph-chart-pie': ChartPie,
  'mph-dialog-event': DialogEvent,
};
